export const formatImageUrl = (logoUrl: string | undefined | null) => {
  const baseUrl = process.env.REACT_APP_OBJECT_STORAGE_BASE_URL || '';
  if (logoUrl && !logoUrl.startsWith(baseUrl)) {
    return `${baseUrl}/${logoUrl}`;
  }
  return logoUrl;
};
